import { PropsWithChildren, Fragment } from 'react'
import { Tooltip as BaseTooltip, TooltipWrapper } from './Tooltip.style'

interface TooltipProps {
  disabled?: boolean
  tooltipText: string
  disablePortal?: boolean
  placedRight?: boolean
}

const Tooltip = ({
  children,
  disabled,
  tooltipText,
  disablePortal = true,
  placedRight = true,
  ...props
}: PropsWithChildren<TooltipProps>) => {
  const Wrapper = disablePortal ? TooltipWrapper : Fragment

  return disabled ? (
    <Wrapper {...props}>
      <BaseTooltip
        PopperProps={{ disablePortal }}
        placement={placedRight ? 'top-end' : 'top-start'}
        title={tooltipText}
      >
        <span>{children}</span>
      </BaseTooltip>
    </Wrapper>
  ) : (
    <>{children}</>
  )
}

export default Tooltip
